<template>
	<div class="page-form">

		<h1 v-if="title">
			{{title}}
		</h1>
		<div class="pageSubtitle">{{subtitle}}</div>

		<slot name="content"></slot>
		<slot name="nav"></slot>

	</div>
</template>

<!-- ================================================================================== -->

<script>
	export default {
		name:"PageForm",
		components: {
		},
		props: {
			title: {
				type: String,
				required: false,
			},
			subtitle: {
				type: String,
				required: false,
			},
		}
	}
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>
</style>
